import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DateSlot from '@components/DataGrid/DateSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const availabilityDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'E Avail',
	minWidth: 120,
	width: 120,
	headerName: 'E Avail',
	renderHeader: () => <RenderHeader primaryText='E Avail' />,
	renderCell: ({ row }) => <RenderCell primarySlot={<DateSlot toDate={row.emptyAvailableDate} />} />,
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { available } = row;
				return caseInsensitiveIncludes(value, available);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.emptyAvailableDate?.date ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default availabilityDefinition;
